import { useEffect, useState } from "react";

/**
 * Suppresses skeleton flashes on fast responses by only flipping to `true`
 * after `delayMs` of continuous loading. When `loading` becomes false, the
 * delayed flag flips to false immediately.
 */
export function useDelayedLoading(loading: boolean, delayMs = 200): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!loading) {
      setDelayed(false);
      return;
    }
    const t = window.setTimeout(() => setDelayed(true), delayMs);
    return () => window.clearTimeout(t);
  }, [loading, delayMs]);

  return delayed;
}
